export enum MaterialListFormValue {
  DESCRIPTION = 'Description',
}
